module.exports = __webpack_public_path__ + "static/media/LogoVS.32a19b98.png";